/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_IncludedInputs */

const en_plan_included = /** @type {(inputs: Plan_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Included`)
};

const es_plan_included = /** @type {(inputs: Plan_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluido`)
};

/**
* | output |
* | --- |
* | "Included" |
*
* @param {Plan_IncludedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_included = /** @type {((inputs?: Plan_IncludedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_IncludedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_included(inputs)
	return en_plan_included(inputs)
});